import React, { useEffect, useState } from 'react';
import { base_url, blogArr, supportUs } from '../constant/Appconstants';
import { useNavigate } from 'react-router-dom';
import { IoSearch } from "react-icons/io5";
import moment from 'moment';
import axios from 'axios';
import { message,Pagination } from 'antd'
import { GetBlogServices } from '../services/BlogServices';

function Blogs() {
  
  const navigator = useNavigate()
  const [singleData,setsingleData] = useState({})
  const [datas,setdatas] = useState([])
  const [page,setpage] = useState(1)



  // useEffect(()=>{
  //   setdatas(blogArr)
  //   setsingleData(blogArr[0])
  // },[])

  useEffect(()=>{
    getData()
  },[page])

  async function getData(){
    const response = await GetBlogServices(page,search?.text)
    setdatas(response?.data)
    if(response?.data?.datas?.length > 0){
      setsingleData(response?.data?.datas[0])
    }
  }


  const [data,setdata] =  useState({name:'',mobile:'',email:'',requirment:'',service:''})


  const [search,setsearch] = useState('')

  async function handleSubmit(e){
    if (e.key === 'Enter') {
      if(search?.length > 0){
        const response = await GetBlogServices(page,search)
        setdatas(response?.data)
        if(response?.data?.datas?.length > 0){
          setsingleData(response?.data?.datas[0])
        }else{
          setsingleData(null)
        }

        // let sendData =  datas.filter((f)=>f.heading.toLowerCase().includes(search.toLowerCase()))
        // setdatas(sendData)
      }else{
        const response = await GetBlogServices(page,'')
        setdatas(response?.data)
        if(response?.data?.datas?.length > 0){
          setsingleData(response?.data?.datas[0])
        }else{
          setsingleData(null)
        }
      }
    }
  }
  

  async function openDetail(v){
    navigator(`/blogs/detail/${v?._id}`)
  }


  async function submitForm(){
      if(data?.email !== ''){ 
        const sendData = {...data}
        await axios.post(`${base_url}clients/create`,sendData)
        .then((res)=>{
          if(res?.status === 201){
            message.success('Blog Subscribed Successfully')
            setdata({name:'',mobile:'',email:'',requirment:'',department_website:'',service:''})
          }
        }).catch((err)=>{      
        }) 
      }
  }
  
  

   
   
  return (
    <div className='w-screen '>
        {/* <div className='relative flex items-center justify-center bg-no-repeat bg-blogs_bg bg-bottom bg-cover h-[200px]  md:h-[340px]'>
           <div className='z-10'>
            <h6 className='text-[30px] text-white text-center tracking-[10px] font_thicker opacity-80'>Our Blogs</h6>
            <h6 className='text-center font_normal text-white opacity-100 text-[14px]'> <span onClick={()=>navigator('/')} className='relative cursor-pointer after:bg-[#fff] after:absolute after:h-[2px] after:w-0 after:bottom-0 after:left-0  text-white opacity-100  hover:after:w-full after:transition-all after:duration-300'>Home</span> / Blogs </h6>
            <h6 className='text-[13px] mt-1  text-white text-center font_normal opacity-80'>Would love to hear some of the blogs related to Interior and Business growth. </h6>
           </div>
           <div className='bg-black opacity-60 absolute top-0 left-0 w-full h-[200px]  md:h-[340px]'>
           </div> 
        </div> */}

        <div className='min-h-[200px]  relative md:min-h-[240px] 2xl:min-h-[500px] bg-contain md:bg-cover bg-no-repeat w-full bg-blogs_bg bg-cover'>
          <div data-aos="fade-left" className='absolute top-[3%] md:top-[15%]  w-[75%] md:w-[35%]' >
            <div className='border-l w-full border-l-4  border-l-[#4190ac] ml-[6%] pl-[1.5%] absolute top-[100px] md:top-[15%]'>
                <h6 className='text-[18px] md:text-[21px] 2xl:text-[24px] text-[#000] font_thicker font-[800]  '>Our Blogs</h6>
                <h6 className='text-[13px] md:text-[14px] 2xl:text-[17px] text-[#000] font_normal'>Would love to hear some of the blogs related to Interior and Business growth. </h6>
            </div>
          </div>
        </div>


        <div className='grid grid-cols-1  mx-[5%] md:mx-[10%] my-[5%] md:grid-cols-3 md:gap-5'>
            {/* {blogsArr?.map((b,i)=>(
                <div className='mb-5 md:mb-0' data-aos="fade-up" onClick={()=>openDetail(b)}>
                   <img src={b?.img} className='h-[170px] w-[100%]' />
                   <h6 className='font_bold text-[13px] mt-3'>{b?.heading}</h6>
                   <h6 className='truncate font_normal text-gray-500 text-[12px] mt-1'>{b?.short_description}</h6>
                   <div className='flex items-start mt-1 border-t pt-1.5 border-gray-100'>
                    {(b?.written_image !== null && b?.written_image !== undefined) &&
                    <img src={b?.written_image} className='w-[30px] h-[30px] object-contain bg-slate-100 rounded-full' />}
                    <div className='ml-2 -mt-1'>
                    {(b?.written_image !== null && b?.written_image !== undefined) && <h6 className='font_bold  text-[#4190ac] text-[12px] mt-1'>{b?.written_by}</h6>}
                    <div className='flex items-center -mt-1'>
                        <h6 className='font_normal  text-[10px] mt-1'>{moment(b?.date)?.format('LL')}</h6>
                        <h6 className=' ml-2 font_bold  text-[10px] mt-1'>{b?.read}</h6>
                    </div>
                    </div>    

                   </div> 
                </div>    
            ))} */}

            {datas?.datas?.map((b,i)=>(
              <div className='mb-5 md:mb-0' data-aos="fade-up" onClick={()=>openDetail(b)}>
                  <img src={`${process.env.REACT_APP_AWS_IMAGE_URL}${b?.blog_image}`} className='h-[170px] w-[100%]' />
                  <h6 className='font_thicker text-[13px] 2xl:text-[16px] mt-3'>{b?.title}</h6>
                  <h6 className='truncate font_normal text-gray-500 text-[12px] 2xl:text-[15px] mt-1'>{b?.motive}</h6>
                  <div className='flex items-start mt-1 border-t pt-1.5 border-gray-100'>
                  {(b?.written_by?.profile_photo !== null && b?.written_by?.profile_photo !== undefined) ?
                  <img src={`${process.env.REACT_APP_AWS_IMAGE_URL}${b?.written_by?.profile_photo}`} className='w-[30px] h-[30px] object-contain bg-slate-100 rounded-full' />
                  :
                  <h6 className='w-[24px] h-[24px] flex items-center justify-center text-[11px] 2xl:text-[13px] font_bold text-white rounded-full' style={{background:b?.color === undefined ? '#fafafa' : b?.color}}>{b?.written_by?.name?.slice(0,1)}</h6>
                  }
                  <div className='ml-2 -mt-1'>
                  {(b?.written_by !== null && b?.written_by !== undefined) && <h6 className='font_bold  text-[#4190ac] text-[12px] mt-1'>{b?.written_by?.name}</h6>}
                  <div className='flex items-center -mt-1'>
                      <h6 className='font_normal  text-[10px] 2xl:text-[13px] mt-1'>{moment(b?.date)?.format('LL')}</h6>
                      <h6 className=' ml-2 font_bold  text-[10px] 2xl:text-[13px] mt-1'>{b?.min_read}</h6>
                  </div>
                  </div>    

                  </div> 
              </div>    
            ))}

         </div>


      
    </div>

  )
}

export default Blogs